import { render } from "./FarmWidget.vue?vue&type=template&id=296f2118"
import script from "./FarmWidget.vue?vue&type=script&lang=js"
export * from "./FarmWidget.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/lf.m2geo.ie/releases/20261103161156/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Farmer/Partials/FarmWidget.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "296f2118"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('296f2118', __exports__)) {
    console.log('reload')
    api.reload('296f2118', __exports__)
  }
  
  module.hot.accept("./FarmWidget.vue?vue&type=template&id=296f2118", () => {
    console.log('re-render')
    api.rerender('296f2118', render)
  })

}


export default __exports__